import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { LinkButton } from "./styles";

function BaseLinkButton({ label, path }) {
  return (
    <LinkButton to={path}>
      {label}
      <ArrowForwardIcon
        className="arrow-icon"
        sx={{
          fontSize: "1em !important",
        }}
      />
    </LinkButton>
  );
}

export default BaseLinkButton;
